module.exports = __webpack_public_path__ + "img/country-kitchen.2996ce7b.png";